import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OverlayService {
  // Signal to track overlay visibility
  readonly isOverlayVisible = signal(true);

  // Method to hide the overlay
  hideOverlay(): void {
    this.isOverlayVisible.set(false);
  }
}